module.exports = __webpack_public_path__ + "img/banner3.81f09319.png";